module.exports = __webpack_public_path__ + "img/d2aad3b.png";